class StickyATC extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    // Clean up any existing event listeners
    this.cleanup();

    // Attendre que le DOM soit complètement chargé
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initializeElements();
      });
    } else {
      this.initializeElements();
    }
  }

  initializeElements() {
    // Initialize properties avec retry pour mobile
    this.findElements();

    // Si les éléments critiques ne sont pas trouvés, retry
    if (!this.originalForm) {
      setTimeout(() => {
        this.findElements();
        if (this.originalForm) {
          this.startInitialization();
        }
      }, 100);
      return;
    }

    this.startInitialization();
  }

  findElements() {
    // Essayer plusieurs sélecteurs pour le formulaire original
    this.originalForm =
      document.querySelector('.product product-form') ||
      document.querySelector('product-form') ||
      document.querySelector('[data-product-form]') ||
      document.querySelector('.product-form');

    this.productInfoContainer = document.querySelector('.product .product__info-container');
    this.productImage = document.querySelector('.product .product__media-gallery img');
    this.mainPriceElement = document.querySelector('.product .product-price');
    this.atcButton = this.querySelector('.sticky-atc__button');
    this.variantSelectContainer = this.querySelector('.sticky-atc__variant-container');
    this.priceContainer = this.querySelector('.sticky-atc__price');
    this.productImageElement = this.querySelector('.sticky-atc__image img');
    this.titleElement = this.querySelector('.sticky-atc__title');

    // Initialize state
    this.threshold = 200;
    this.isVisible = false;
    this.isFormVisible = false;
    this.retryCount = 0;
    this.maxRetries = 5;

    // Cache pour optimiser les performances
    this.cachedFormRect = null;
    this.lastScrollY = 0;
    this.ticking = false;
  }

  startInitialization() {
    if (!this.originalForm) return;

    // Initialize components avec requestIdleCallback pour éviter de bloquer l'INP
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        this.initializeIntersectionObserver();
        this.initializeWindowScrollListenner();
        this.initializeVariantPicker();
        this.initializeButtonATC();
        this.updateVisibility();
      });
    } else {
      setTimeout(() => {
        this.initializeIntersectionObserver();
        this.initializeWindowScrollListenner();
        this.initializeVariantPicker();
        this.initializeButtonATC();
        this.updateVisibility();
      }, 0);
    }
  }

  // Clean up event listeners to prevent memory leaks
  cleanup() {
    window.removeEventListener('scroll', this.boundUpdateVisibility);

    if (this.atcButton) {
      this.atcButton.removeEventListener('click', this.boundHandleAtcClick);
    }

    // Disconnect intersection observer
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }

    // Reset button state if it was in loading state
    this.resetButtonState();

    // Clear cache
    this.cachedFormRect = null;
    this.ticking = false;
  }

  initializeIntersectionObserver() {
    // Utiliser Intersection Observer pour détecter quand le formulaire original est visible
    if ('IntersectionObserver' in window && this.originalForm) {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.isFormVisible = entry.isIntersecting;
            // Forcer une mise à jour immédiate pour mobile
            requestAnimationFrame(() => {
              this.updateVisibility();
            });
          });
        },
        {
          threshold: [0, 0.1], // Détecter quand l'élément entre/sort complètement et à 10%
          rootMargin: '0px 0px 0px 0px', // Pas de marge pour éviter les problèmes mobile
        },
      );

      this.intersectionObserver.observe(this.originalForm);
    } else {
      // Fallback si Intersection Observer n'est pas supporté
      this.isFormVisible = false;
    }
  }

  initializeWindowScrollListenner() {
    // Store bound function for later removal avec throttle optimisé
    this.boundUpdateVisibility = this.throttledUpdateVisibility.bind(this);

    // Listen for scroll events to show/hide the sticky ATC avec passive listener
    window.addEventListener('scroll', this.boundUpdateVisibility, { passive: true });
  }

  // Throttle optimisé avec requestAnimationFrame pour de meilleures performances
  throttledUpdateVisibility() {
    this.lastScrollY = window.scrollY;

    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.updateVisibility();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  initializeButtonATC() {
    if (!this.atcButton) return;

    // Store bound function for later removal
    this.boundHandleAtcClick = this.handleAtcClick.bind(this);

    // Listen for clicks on the ATC button
    if (this.atcButton) {
      this.atcButton.addEventListener('click', this.boundHandleAtcClick);
    }
  }

  initializeVariantPicker() {
    if (!this.variantSelectContainer) return;

    // Set up event listener for variant selection changes in the sticky form
    const variantInputs = this.variantSelectContainer.querySelectorAll('input[type="radio"]');
    variantInputs.forEach((input) => {
      input.addEventListener('change', (event) => {
        this.handleStickyVariantChange(event, variantInputs);
      });
    });
  }

  handleStickyVariantChange(event, variantInputs) {
  const selectedVariantInput = event.target;
  const variantId = selectedVariantInput.value;

  // Mettre à jour l'UI du sticky
  this.updateStickyVariantUI(selectedVariantInput, variantInputs);

  // Mettre à jour le titre affiché dans le sticky
  const titleEl = this.querySelector('[data-selected-value]');
  if (titleEl) {
    titleEl.textContent = selectedVariantInput.closest('label').querySelector('.variant-picker-container__modal-body--option-title').textContent;
  }

  // Trouver et déclencher le changement sur le variant-selects principal
  const variantSelects = document.querySelector('variant-selects');
  if (variantSelects) {
    const optionValues = this.getOptionValuesFromVariant(selectedVariantInput);
    const selects = variantSelects.querySelectorAll('select');
    selects.forEach((select, index) => {
      if (index < optionValues.length) {
        select.value = optionValues[index];
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}


  updateStickyVariantUI(selectedVariantInput, variantInputs) {
    // Reset all inputs
    variantInputs.forEach((input) => {
      input.checked = false;
      input.closest('label').classList.remove('variant-picker-container__modal-body--option-selected');
    });

    // Check the selected variant input
    selectedVariantInput.checked = true;
    selectedVariantInput.closest('label').classList.add('variant-picker-container__modal-body--option-selected');
  }

  getOptionValuesFromVariant(variantInput) {
    const optionValues = [];
    let optionIndex = 1;

    // Collect all option values from data attributes
    while (variantInput.hasAttribute(`data-option-${optionIndex}`)) {
      optionValues.push(variantInput.getAttribute(`data-option-${optionIndex}`));
      optionIndex++;
    }

    return optionValues;
  }

  updateMainFormInputs(fieldsets, optionValues) {
    // For each option, find and select the corresponding input in the main form
    fieldsets.forEach((fieldset, index) => {
      if (index < optionValues.length) {
        const optionValue = optionValues[index];

        // Find the input in the main form with this option value
        const mainInput = fieldset.querySelector(`input[type="radio"][value="${optionValue}"]`);

        if (mainInput) {
          mainInput.checked = true;
          mainInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  handleAtcClick() {
    // Set button to loading state
    this.setButtonLoading();

    // Trigger add to cart on the main form
    const submitButton = this.originalForm.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.click();
    }
  }

  setButtonLoading() {
    if (!this.atcButton) return;

    // Disable the button
    this.atcButton.setAttribute('aria-disabled', 'true');

    // Add loading class
    this.atcButton.classList.add('loading');

    // Show loading spinner
    const spinner = this.atcButton.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
    }
  }

  resetButtonState() {
    if (!this.atcButton) return;

    // Remove loading class
    this.atcButton.classList.remove('loading');

    // Enable the button
    this.atcButton.removeAttribute('aria-disabled');

    // Hide loading spinner
    const spinner = this.atcButton.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.add('hidden');
    }
  }

    updateVisibility() {
    // Barre d'achat fixe affichée en permanence sur la fiche produit
    if (!this.isVisible) {
      this.classList.add('sticky-atc--visible');
      document.body.classList.add('sticky-atc--visible');
      this.isVisible = true;
    }
  }
}

customElements.define('sticky-atc', StickyATC);
